module.exports = {
  title: 'Enhanced Fibonacci Sphere with React Native Skia 🌐',
  author: 'Enzo Manuel Mangano',
  date: '2024-01-24',
  slug: 'fibonacci-shader-grid',
  tags: ['skia', 'reanimated', 'gesture-handler'],
};
